export default {
  image: 'r1.jpg',
  productData: {
    name: 'Robustes System R1',
    shorthand: "R1",
    advantages: [
      "Robust",
      "Volle Farbtonvielfallt",
      "Reinigungsfähig",
      "Langlebig"
    ],
    technical: [
      "Feuchtraum WO-I",
      "Volle Farbtonauswahl",
      "Glatte Flächen",
      "Glanzgrad seidenmatt/seidenglänzend",
      "Erhöhte optische Ansprüche",
      "TÜV"
    ],
    systemStructure: [
      {
        type: 'subsurface',
        layer: 1,
        products: [0],
        selectedProduct: 0,
        changedProduct: false
      },
      {
        type: 'joints',
        layer: 2,
        products: [1],
        selectedProduct: 1,
        changedProduct: false
      },
      {
        type: 'surfaceFilling',
        layer: 3,
        products: [9],
        selectedProduct: 9,
        changedProduct: false
      },
      {
        type: 'firstCoat',
        layer: 4,
        products: [3],
        selectedProduct: 3,
        changedProduct: false
      },
      {
        type: 'glue',
        layer: 5,
        products: [23],
        selectedProduct: 23,
        changedProduct: false
      },
      {
        type: 'wallCovering',
        layer: 6,
        products: [24, 25, 26],
        selectedProduct: 24,
        changedProduct: false
      },
      {
        type: 'finalCoatLayer1',
        layer: 7,
        products: [39],
        selectedProduct: 39,
        changedProduct: false
      },
      {
        type: 'finalCoatLayer2',
        layer: 7,
        products: [39],
        selectedProduct: 39,
        changedProduct: false
      }
    ],
    construction: {
      composition: [
        {
          title: { de: 'Systemgruppen' },
          output: 'Robustes System',
          type: 'systemGroup',
          value: 'systemgroup-3'
        },
        {
          title: { de: 'Räume' },
          output: 'Wohnräume',
          type: 'room',
          value: 'room-1'
        },
        {
          title: { de: 'Räume' },
          output: 'Küche',
          type: 'room',
          value: 'room-3'
        },
        {
          title: { de: 'Räume' },
          output: 'Flur',
          type: 'room',
          value: 'room-4'
        },
        {
          title: { de: 'Umwelt- und Gesundheitsaspekte' },
          output: 'Schadstoffgeprüft',
          type: 'environmentHealth',
          value: 'environmenthealth-1'
        },
        {
          title: { de: 'Umwelt- und Gesundheitsaspekte' },
          output: 'TÜV',
          type: 'environmentHealth', 
          value: 'environmenthealth-2'
        },
        {
          title: { de: 'Belastbarkeit' },
          output: 'Reinigungsfähig',
          type: 'resilience', 
          value: 'resilience-4'
        },
        {
          title: { de: 'Belastbarkeit' },
          output: 'Desinfektionsmittelbeständig',
          type: 'resilience', 
          value: 'resilience-5'
        },
        {
          title: { de: 'Belastbarkeit' },
          output: 'Risssicher',
          type: 'resilience', 
          value: 'resilience-6'
        },
        {
          title: { de: 'Belastbarkeit' },
          output: 'Langlebig',
          type: 'resilience', 
          value: 'resilience-7'
        },
        {
          title: { de: 'Design / Oberfläche' },
          output: 'Satinmatt',
          type: 'designSurface', 
          value: 'designsurface-2'
        },
        {
          title: { de: 'Design / Oberfläche' },
          output: 'Volle Farbtonauswahl',
          type: 'designSurface', 
          value: 'designsurface-5'
        },
        {
          title: { de: 'Design / Oberfläche' },
          output: 'Glatt',
          type: 'designSurface', 
          value: 'designsurface-6'
        },
        {
          title: { de: 'Design / Oberfläche' },
          output: 'Erhöhte optische Ansprüche',
          type: 'designSurface', 
          value: 'designsurface-8'
        },
        {
          title: { de: 'Verarbeitungszeit' },
          output: 'Stufe 2',
          type: 'processingTime', 
          value: 'processingtime-2'
        },
        {
          title: { de: 'Preisniveau' },
          output: '€€',
          type: 'priceLevel', 
          value: 'pricelevel-2'
        }
      ]
    }
  }
}
